module.exports = __webpack_public_path__ + "img/38.d9a973b5.webp";